import { RootState } from '../types';

export const retailModeSelector = (state: RootState) => state.app.retailMode;

export const soundsSelector = (state: RootState) => state.app.sounds;

export const promptStatesSelector = (state: RootState) => state.app.promptStates;
